export enum FileType {
  front,
  back,
  signature,
}

export function getFileName(type: FileType): string {
  return type === FileType.front
    ? 'card_recto.jpg'
    : type === FileType.back
    ? 'card_verso.jpg'
    : 'signature.jpg';
}
